<app-devices-tab [itemCollection]="factoryDeepList" [buttonActive]="true"
[title]="factory?.descripcion" (itemSelected)="selectedItem($event)" (itemUnselected)="unSelectedItem($event)" 
[deviceSettings]="deviceSettings" [loading]="loadingChildren"></app-devices-tab>